import React from "react";
import ManualBuilder from "./index";
import ManualBuilderV2 from "./v2/ManualBuilderV2";
import { Feature, useFeatureFlags } from "context/FeatureFlag";

/**
 * Switch component that allows toggling between the original ManualBuilder (V1)
 * and the new ManualBuilderV2 implementation.
 *
 * Set REACT_APP_MANUAL_BUILDER_V2=true in .env.local to enable V2
 *
 * This allows for:
 * - Safe rollout of V2 without affecting production
 * - Easy rollback if issues are found
 * - A/B testing and gradual migration
 */
const ManualBuilderSwitch = () => {
  const { isFeatureEnabled } = useFeatureFlags();

  if (isFeatureEnabled(Feature.ManualV2)) {
    console.log("🚀 ManualBuilder V2 enabled");
    return <ManualBuilderV2 />;
  }

  console.log("📝 ManualBuilder V1 (original)");
  return <ManualBuilder />;
};

export default ManualBuilderSwitch;
